module.exports = __webpack_public_path__ + "img/Back Door Left Salone.0426c875.png";